import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { KofferComponent } from './koffer/koffer.component';
import { HelpPageComponent } from './help-page/help-page.component';
import { MissionCardDetailComponent } from './core/components/mission-card-detail/mission-card-detail.component';
import { SendDataComponent } from './send-data/send-data.component';
import { ActivationPageComponent } from './activation-page/activation-page.component';
import { activationGuard } from './core/guards/activation.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomePageModule),
    canActivate: [activationGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'mission/:mission',
    component: MissionCardDetailComponent,
    canActivate: [activationGuard],
  },
  {
    path: 'koffer',
    component: KofferComponent,
    canActivate: [activationGuard],
  },
  {
    path: 'help',
    component: HelpPageComponent,
    canActivate: [activationGuard],
  },
  {
    path: 'send-data',
    component: SendDataComponent,
    canActivate: [activationGuard],
  },
  {
    path: 'activation',
    component: ActivationPageComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
